import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedMimecastV2App from "./EmbeddedMimecastV2App";
const MimecastV2App = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("mimecastv2.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("mimecastv2.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedMimecastV2App, null));
};
export default MimecastV2App;
